import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings, AppSettingsInputModel } from '../model';

const baseUrl = '/api/app-settings';

@Injectable({ providedIn: 'root' })
export class AppSettingsClient {
    private readonly _http = inject(HttpClient);

    get(): Observable<AppSettings> {
        return this._http.get<AppSettings>(`${baseUrl}`);
    }

    save(model: AppSettingsInputModel) {
        return this._http.post(`${baseUrl}`, model);
    }
}
